import React from 'react';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageSwitch } from './LanguageSwitch';
import { Logo } from './ui/Logo';
import { ServiceDropdown } from './ServiceDropdown';

export function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);
  const { t } = useLanguage();

  const handleClickOutside = (e: MouseEvent) => {
    if (isOpen && !(e.target as Element).closest('.mobile-menu')) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  const navLinks = [
    { href: '#projects',    label: t('nav.projects') },
    { href: '#how-we-work', label: t('nav.howwework') },
    { href: '#founder',     label: t('nav.founder') },
  ];

  return (
    <nav className="bg-white/90 backdrop-blur-sm shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Logo />
          </div>

          {/* Desktop */}
          <div className="hidden md:flex items-center space-x-6">
            <ServiceDropdown />
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-gray-600 hover:text-primary transition-colors duration-300 text-sm font-medium"
              >
                {l.label}
              </a>
            ))}
            <LanguageSwitch />
            <a
              href="#contact"
              className="bg-accent text-white px-4 py-2 rounded-md hover:bg-accent-dark transition-colors duration-300 text-sm font-medium"
            >
              {t('nav.contact')}
            </a>
          </div>

          {/* Mobile Hamburger */}
          <div className="md:hidden flex items-center space-x-4">
            <LanguageSwitch />
            <button
              onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}
              className="text-primary p-2"
              aria-label="Toggle menu"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden mobile-menu">
          <div className="px-4 pt-2 pb-3 space-y-1 bg-white shadow-lg">
            <div className="py-2">
              <ServiceDropdown />
            </div>
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="block px-4 py-2 text-accent font-medium hover:text-accent-dark transition-colors duration-300"
                onClick={() => setIsOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              className="block px-4 py-2 text-accent font-medium hover:text-accent-dark transition-colors duration-300"
              onClick={() => setIsOpen(false)}
            >
              {t('nav.contact')}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
